import VerifyCodeByPhone from './VerifyCodeByPhone'

export default VerifyCodeByPhone
